module.exports = __webpack_public_path__ + "static/img/numman.8f780878.png";